export const createNumberedArray = (length: number, startNum = 1) =>
  Array.from(Array(length).keys()).map((_, i) => startNum + i);
